module.exports = __webpack_public_path__ + "img/red.7a3d5580.svg";